import { makeActionCreator } from '../../../utilities'
import { AdditionalAssessmentsConstants } from './additionalAssessments.constants'

export const setSelectedAssessment = makeActionCreator(
  AdditionalAssessmentsConstants.SET_SELECTED_ASSESSMENT,
  'selectedAssessment'
)
export const setAssessmentsList = makeActionCreator(
  AdditionalAssessmentsConstants.SET_BODY_SURVEY_ASSESSMENT_LIST,
  'bodySurveys'
)
export const setAssessmentSummaryDate = makeActionCreator(
  AdditionalAssessmentsConstants.SET_ASSESSMENT_SUMMARY_DATE,
  'assessmentSummaryDate'
)
export const setAssessmentSeq = makeActionCreator(AdditionalAssessmentsConstants.SET_ASSESSMENTS_SEQUENCE, 'seq')
export const deleteAssessment = makeActionCreator(AdditionalAssessmentsConstants.DELETE_ASSESSMENT, 'deleteAssessment')
export const resetAssessments = makeActionCreator(AdditionalAssessmentsConstants.RESET_ASSESSMENTS)
export const setAssessmentSummaryUpdatedFinding = makeActionCreator(
  AdditionalAssessmentsConstants.SET_ASSESSMENT_SUMMARY_UPDATED_FINDING,
  'updatedFindings'
)
export const resetSelectedAssessment = makeActionCreator(AdditionalAssessmentsConstants.RESET_SELECTED_ASSESSMENT)
